import React from "react";
import { Calendar } from "lucide-react";

type FormDateInputProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  max?: string;
  required?: boolean;
};

export const FormDateInput: React.FC<FormDateInputProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  max,
  required = false,
}) => {
  return (
    <div>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Calendar className="h-4 w-4 text-gray-400" />
        </div>
        <input
          type="date"
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          max={max}
          className={`block w-full pl-10 pr-3 py-2.5 border rounded-lg focus:ring-1 focus:ring-orange-500 focus:border-orange-500 text-gray-900 ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};
